/**
 * Async setTimeout
 * @param {number} timeout
 * @param {any[]} args
 */
export default function setTimeoutAsync(timeout, ...args) {
    return new Promise((resolve, reject) => {
        try {
            window.setTimeout(() => {
                resolve();
            }, timeout, args);
        } catch (error) {
            reject(error);
        }
    });
}
